export default __webpack_public_path__ + "static/media/celcomlogo.dc6b3278.png";